import { Link } from "react-router-dom";

// Brand lockup. Full lockup (icon + wordmark) via /logos/pepdirect-full.webp
// is used in the header, footer and any transactional context. Falls back
// to the icon-only mark on very narrow viewports where the wordmark would
// clip. The old inline SVG chevron was retired in favour of the shipped
// asset, see /public/logos/pepdirect-icon.webp.
//
// The dark prop applies a CSS invert+brightness filter so the same navy
// lockup asset renders as a white/pale silhouette on dark backgrounds
// (footer, navy sections). Cheaper than shipping a second asset.
export default function Logo({ dark = false, className = "" }) {
  const filter = dark ? "brightness(0) invert(1)" : undefined;
  return (
    <Link to="/" className={`flex items-center ${className}`} data-testid="brand-logo">
      <picture>
        <source srcSet="/logos/pepdirect-full.webp" type="image/webp" />
        <img
          src="/logos/pepdirect-full.webp"
          alt="PepDirect"
          className="hidden h-8 w-auto align-middle sm:block"
          style={filter ? { filter } : undefined}
          draggable={false}
        />
      </picture>
      {/* Icon-only fallback on very narrow mobile, keeps the header from
          crowding the hamburger + cart. */}
      <img
        src="/logos/pepdirect-icon.webp"
        alt="PepDirect"
        className="h-8 w-8 align-middle sm:hidden"
        style={filter ? { filter } : undefined}
        draggable={false}
      />
      <span className="sr-only">PepDirect</span>
    </Link>
  );
}
